import { useMemo } from 'react';

import { escapeRegex } from '../../utils/escape-regex';
import type { HighlighterChunk, HighlighterPropsInterface } from './types/highlighter.types';

export const useHighlighterChunks = (
  props: Pick<HighlighterPropsInterface, 'text' | 'pattern'>,
): Array<HighlighterChunk> => {
  const { text, pattern } = props;

  return useMemo(() => {
    if (!pattern) return [{ text, highlight: false, key: 0 }];

    const chunks: Array<HighlighterChunk> = [];

    const regex =
      typeof pattern === 'string'
        ? new RegExp(escapeRegex(pattern), 'ig')
        : new RegExp(pattern, 'ig');

    let lastIndex = 0;
    let match: RegExpExecArray | null;
    let key = 0;

    while ((match = regex.exec(text)) !== null) {
      if (lastIndex !== match.index) {
        chunks.push({
          text: text.slice(lastIndex, match.index),
          highlight: false,
          key: key++,
        });
      }

      chunks.push({
        text: match[0],
        highlight: true,
        key: key++,
      });

      lastIndex = regex.lastIndex;
    }

    if (lastIndex < text.length) {
      chunks.push({
        text: text.slice(lastIndex),
        highlight: false,
        key: key++,
      });
    }

    return chunks;
  }, [text, pattern]);
};
